let formSerializeObject = (wrapId, elemWrap = null) => {
    const wrap = wrapId ? document.getElementById(wrapId) : elemWrap;
    let list = {};

    if (wrap) {
        const elements = wrap.querySelectorAll('input,select,textarea');

        for (let elem of elements) {
            if (elem.name) {
                if (elem.type === 'file') {
                    list[elem.name] = elem.files;
                } else if (elem.type === 'radio' && elem.checked) {
                    list[elem.name] = elem.value;
                } else if (elem.type !== 'radio') {
                    list[elem.name] = elem.value;
                }
            }
        }
    }

    return list;
};

export default formSerializeObject;
